module.exports = __webpack_public_path__ + "img/1527482920.23d47508.jpg";